export const HOME = {
  emergentLink: 'emergent-link',
  heroSection: 'hero-section',
  uploadButton: 'upload-button',
  trustSection: 'trust-section',
  howItWorksSection: 'how-it-works-section',
  exampleAnalysisSection: 'example-analysis-section',
  timelineSection: 'timeline-section',
  pricingSection: 'pricing-section',
  finalCtaSection: 'final-cta-section'
};

export const UPLOAD = {
  dropzone: 'dropzone',
  fileInput: 'file-input',
  uploadedFile: 'uploaded-file',
  analyzeButton: 'analyze-button',
  loadingState: 'loading-state'
};

export const DASHBOARD = {
  container: 'dashboard-container',
  documentCard: 'document-card',
  summarySection: 'summary-section',
  keyDatesSection: 'key-dates-section',
  keyAmountsSection: 'key-amounts-section',
  actionsSection: 'actions-section',
  glossaryButton: 'glossary-button',
  emailButton: 'email-button',
  timelineSection: 'timeline-section',
  glossaryModal: 'glossary-modal',
  emailModal: 'email-modal'
};